<template>
    <div name="medicals" class="medicals">
        <div style="width: 100%;display: flex; flex-direction: column; align-items: flex-start; ">
            <span class="title">진료 과목</span>
            <div class="subject-wrapper">{{ fixSubject }}</div>
        </div>
        <div style="width: 100%; margin-top: 20px;">
            <div class="section-header" @click="toggleExpand">
                <span class="title">진료 항목</span>
                <div class="expand-icon" :class="{ expanded: isExpanded }" v-if="isOverflow">
                    <svg width="20" height="20" viewBox="0 0 20 20">
                        <path d="M4 7L10 13L16 7" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div class="department-list">
                <div class="department-box" v-for="(info, index) in departments" v-if="info.is_enabled && info.value != 6" :key="`department_${index}`">
                    {{ info.name }}
                </div>
            </div>
            <div ref="listWrapper" class="list-wrapper" :class="{ expanded: isExpanded }">
                <div ref="subjectList" class="list">
                    {{ subjects }}
                </div>
            </div>
            <span class="info-text">*대면/비대면 여부에 따라 진료 가능 항목에 차이가 있을 수 있습니다.</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'medicals',
    props: ['departments', 'subjects', 'fixSubject'],
    data() {
        return {
            isExpanded: false,
            isOverflow: false
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.checkOverflow();
        });
    },
    watch: {
        subjects() {
            this.$nextTick(() => {
                this.checkOverflow();
            });
        }
    },
    methods: {
        checkOverflow() {
            const list = this.$refs.subjectList;
            if (!list) return;
            // line-height 22px * 3줄 = 66px
            this.isOverflow = list.scrollHeight > 66;
        },
        toggleExpand() {
            if (this.isOverflow) {
                this.isExpanded = !this.isExpanded;
            }
        }
    }
}
</script>

<style scoped>
    .medicals {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 20px 16px;
        border-radius: 6px;
        background: var(--gray-00, #FFF);
        box-shadow: 0 0 10px 0 rgba(0, 33, 56, 0.09);
        margin-bottom: 16px;
        margin-top: 16px;
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
    }
    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
    }
    .expand-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.3s ease;
        color: #666;
    }
    .expand-icon.expanded {
        transform: rotate(180deg);
    }
    .list-wrapper {
        overflow: hidden;
        max-height: 105px;
        transition: max-height 0.3s ease;
        margin-top: -22px;
        margin-bottom: 12px;
    }
    .list-wrapper.expanded {
        max-height: 500px;
    }
    .list {
        width: 100%;
        margin: 0;
        margin-top: 16px;
        white-space: pre-line;
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
    }
    .department-list {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 16px;
        flex-wrap: wrap;
        gap: 4px;
    }
    .department-box {
        display: flex;
        padding: 5px 8px;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border-radius: 3px;
        border: 1px solid var(--gray-30-stroke-disabled, #E8EAEE);
        background: var(--Gray-00, #FFF);
    }
    .info-text {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px; /* 133.333% */
        margin-top: 16px;
    }
    .subject-wrapper {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        height: 26px;
        border-radius: 3px;
        background: var(--Gray-20, #F3F5F8);
        padding: 0 8px;
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px; /* 133.333% */
        margin-top: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/hospital/Medicals.vue